import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';

import { usePageView } from '@feedback/hooks';

import drawRoutes from '../../router/utils/drawRoutes';

import createQueryRendererModern from '../../relay/createQueryRendererModern';
import DomainNotFound from '../../router/middlewares/DomainNotFound';
import { useDomainName } from '../../router/middlewares/useDomainName';
import { useUnauthenticated } from '../../router/middlewares/useUnauthenticated';
import { RouteType } from '../../router/utils/types';
import { getDomainName } from '../../security/authentication';

import { AuthenticationTemplate_query } from './__generated__/AuthenticationTemplate_query.graphql';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0px;
  padding: 0px;
  justify-content: center;
  background-blend-mode: multiply;
  background-image: linear-gradient(233deg, #d9e0e9, #ffffff 46%, #d9e0e9);
`;

type Props = {
  routes: RouteType[];
  query: AuthenticationTemplate_query;
};
const AuthenticationTemplate = ({ routes, query }: Props) => {
  const { company } = query;
  const validDomainName = useDomainName(company);

  usePageView();
  useUnauthenticated(company);

  if (!validDomainName) {
    return <DomainNotFound domainName={getDomainName()} />;
  }

  return <Wrapper>{drawRoutes(routes)}</Wrapper>;
};

const AuthenticationTemplateFragment = createFragmentContainer(
  AuthenticationTemplate,
  {
    query: graphql`
      fragment AuthenticationTemplate_query on Query {
        company: companyDomainName {
          ...useDomainName_company @relay(mask: false)
          ...useUnauthenticated_company @relay(mask: false)
        }
      }
    `,
  },
);

export default createQueryRendererModern(AuthenticationTemplateFragment, {
  query: graphql`
    query AuthenticationTemplateQuery {
      ...AuthenticationTemplate_query
    }
  `,
  loadingView: null,
});
